var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-youtube","data-name":"Icon awesome-youtube","d":"M43.114,9.226a5.4,5.4,0,0,0-3.8-3.823c-3.35-.9-16.785-.9-16.785-.9S9.1,4.5,5.746,5.4a5.4,5.4,0,0,0-3.8,3.823c-.9,3.372-.9,10.408-.9,10.408s0,7.036.9,10.408a5.318,5.318,0,0,0,3.8,3.762c3.35.9,16.785.9,16.785.9s13.434,0,16.785-.9a5.318,5.318,0,0,0,3.8-3.762c.9-3.372.9-10.408.9-10.408s0-7.036-.9-10.408Zm-24.977,16.8V13.246l11.229,6.388L18.137,26.022Z","transform":"translate(-1.05 -4.5)","fill":"#fff"}));
}

Youtube.defaultProps = {"id":"youtube_icon","data-name":"youtube icon","width":"42.962","height":"30.208","viewBox":"0 0 42.962 30.208"};

module.exports = Youtube;

Youtube.default = Youtube;
